export const businessTypeObj = {
  b2b: 'b2b',
  b2c: 'b2c',
};

// Manage Access
export const userStatus = {
  Active: 'active',
  Inactive: 'inactive',
};

export const roleChangeType = {
  Add: 'add',
  Remove: 'remove',
};

export const settingTabs = {
  General: 'general',
  Privacy: 'privacy',
  Notification: 'notification',
  EmpDashboard: 'empDashboard',
  SalesData: 'salesData',
  ROICalculations: 'ROICalculations',
  SaleQuantity: 'SaleQuantity',
  GoalPermission: 'GoalPermission',
  DaysAging: 'DaysAging',
  ProductsAndServices: 'ProductsAndServices',
  SalesStageNames: 'SalesStageNames',
  Subscription: 'subscription',
  InviteUser: 'inviteUser',
  ManageAccess: 'manageAccess',
  Commission: 'commission',
  ConfirmSales: 'confirmSales',
  CustomFields: 'customFields',
  Source: 'source',
  HighlightRecognized: 'highlightRecognized',
  BusinessType: 'businessType',
  Contacts: 'contacts',
  Salaries: 'calaries',
  AddTeamMembers: 'addTeamMembers',
  Integration: 'integration',
  Timezone: 'time zone',
  Fiscal: 'fiscal',
  CronTime: 'cronTime',
  WorkflowsPipeline: 'workflows_pipeline',
  WorkflowsTodaysTarget: 'workflows_todaysTargets',
};

export const SETTING_SIDEBAR = {
  GENERAL: 'General',
  USERS: 'Users',
  SALARIES_AND_COMMISSION: 'Salaries & Commissions',
  ADVANCED: 'Advanced',
  ADVANCED_IMPORT: 'Data Import/Export',
  INTEGRATIONS: 'Integrations',
  // TEMPLATES: 'Templates',
  CONTRACTS: 'Contracts & Invoices',
  WORKFLOWS: 'Workflows',
};

export const roleType = {
  Manager: 'manager',
  Employee: 'employee',
  Admin: 'admin',
  Both: 'both',
};
